<template>
  <div>
    <div class="tw-p-4 tw-text-center tw-bg-white tw-shadow-md tw-pt-7">
      <div class="tw-text-lg tw-font-medium tw-leading-6 tw-text-black">
        {{ injury.member.name }}
      </div>
      <div class="tw-text-lg tw-font-medium tw-leading-6 tw-text-black tw-mb-3.5">
        Injury Report Summary Sent
      </div>

      <div class="tw-mb-4 tw-text-base tw-leading-5 tw-text-black">
        The injury report summary has been sent to the following emails:
      </div>

      <div
        class="tw-mb-6 tw-text-base tw-font-medium tw-leading-5 tw-text-black"
        v-for="(email, index) in injuryEmails"
        :key="index"
      >
        <span v-if="memberEmail.emailAddress === email.emailAddress">{{
          convertMemberEmail(email.emailAddress)
        }}</span>
        <span v-else>{{ email.emailAddress }}</span>
      </div>

      <div class="tw-mb-4 tw-text-base tw-font-normal tw-leading-5 tw-text-black">
        Please ensure the required stakeholders have received the email and sufficient treatment and
        a continuous plan is created for the injured player.
      </div>
    </div>

    <div class="sm:tw-flex sm:tw-justify-center">
      <button class="btn-success sm:tw-mr-4" type="success" @click="redirectTo">
        Return to Dashboard
      </button>
      <button class="btn-cancel tw-capitalize" type="" size="medium" @click="reset">
        Create another report
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["injury", "memberEmail"],
  data() {
    return {
      injuryEmails: []
    };
  },
  computed: {},
  mounted() {
    // Find unique emails
    this.injuryEmails = _.uniqWith(this.injury.emails, _.isEqual);
  },
  methods: {
    redirectTo() {
      this.$emit("redirectTo");
    },
    reset() {
      this.$emit("reset", this.injury);
    },
    convertMemberEmail(emailAddress) {
      if (emailAddress) {
        let encryptEmail = "";
        let emailAddressArray = emailAddress.split("@");
        let size = emailAddressArray[0].length;
        if (size > 0) {
          encryptEmail = `${emailAddressArray[0].charAt(0)}***${emailAddressArray[0].substr(
            size - 2
          )}@${emailAddressArray[1]}`;
          return encryptEmail;
        } else {
          return "";
        }
      }
    }
  },
  watch: {}
};
</script>

<style scoped lang="scss">
.container {
  min-height: 100%;
  width: 100%;
  overflow: hidden;
  .card {
    margin: 20px auto;
    width: 50%;
    max-width: 100%;
    overflow: hidden;
    text-align: center;

    .heading {
      font-weight: 600;
    }
  }
  @media only screen and (max-width: $sm) {
    .card {
      width: 80%;
    }
  }
}

.el-row {
  margin-bottom: 20px;
}

.btn-success {
  @apply tw-justify-center tw-w-full tw-mt-8 tw-h-10 tw-rounded-lg  tw-text-sm tw-not-italic tw-font-medium tw-leading-11px tw-tracking-normal tw-text-center tw-text-white  tw-bg-green-700  tw-mb-4 hover:tw-bg-green-300 hover:tw-text-black sm:tw-w-72;
}

.btn-cancel {
  @apply tw-justify-center tw-w-full   sm:tw-mt-8 tw-h-10 tw-rounded-lg  tw-text-sm tw-not-italic tw-font-medium tw-leading-11px tw-tracking-normal tw-text-center tw-text-black   tw-border-2 tw-bg-none hover:tw-border-green-300 tw-border-green-700  sm:tw-w-72;
}
</style>
